<script>
    import FollowsResult from "./FollowsResult.svelte";
    import FollowersResult from "./FollowersResult.svelte";
    import LikersResult from "./LikersResult.svelte";
    import StoriesResult from "./StoriesResult.svelte";
    import PostsAndReelsResult from "./PostsAndReelsResult.svelte";
    import LikesResult from "./LikesResult.svelte";
    import CommentsResult from "./CommentsResult.svelte";
    import AnalyzeStatus from "./AnalyzeStatus.svelte";
    import SubscriptionRequired from "./SubscriptionRequired.svelte";
    export let currentView;
    export let analyze;

    export let params = {};
    export let date;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let identity;
    $: identity = (params && params.identity) ? params.identity : null;
</script>

<AnalyzeStatus {analyze} {params} />

{#if identity}
    {#if currentView === 'follows'}
        <FollowsResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'followers'}
        <FollowersResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'likers'}
        <LikersResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'stories'}
        <StoriesResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'posts_and_reels'}
        <PostsAndReelsResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'likes'}
        <LikesResult {analyze} {params} {path} bind:date />
    {/if}

    {#if currentView === 'comments'}
        <CommentsResult {analyze} {params} {path} bind:date />
    {/if}
{/if}

